import { BIModel } from './BIModel';

export class AddToCartBIModel extends BIModel {
  static eventName = 'add_to_cart';

  #flow;
  #productId;
  #sellerId;
  #productPrice;
  #sellerCost;
  #discount;
  #coupon;
  #countrySeller;

  constructor(userId, flow, productId, sellerId, productPrice, sellerCost, discount, coupon, countrySeller) {
    super(AddToCartBIModel.eventName, userId);
    this.#flow = flow;
    this.#productId = productId;
    this.#sellerId = sellerId;
    this.#productPrice = productPrice;
    this.#sellerCost = sellerCost;
    this.#discount = discount;
    this.#coupon = coupon;
    this.#countrySeller = countrySeller;
  }

  get modelData() {
    return {
        flow: this.#flow,
        product_id: this.#productId,
        seller_id: this.#sellerId,
        product_price: this.#productPrice,
        seller_cost: this.#sellerCost,
        discount: this.#discount,
        coupon: this.#coupon,
        productId: this.#productId,
        country_seller: this.#countrySeller
    };
  }
}
